var ANIMATION_FALL_BACK_TIME_MS = 300;
var SIDE_SHEET_TRANSFORM = 'translate3d(0, 0, 0)';
var SIDE_SHEET_TRANSITION = 'all 0.3s ease-out';
var SIDE_SHEET_CLOSE_BUTTON_ARIA_LABEL = 'Close';
var SIDE_SHEET_CLOSE_KEY = 'Escape';
var SIDE_SHEET_SIZE = {
  s: {
    s: '288px',
    m: '288px',
    l: '288px'
  },
  m: {
    s: '336px',
    m: '442px',
    l: '504px'
  },
  l: {
    s: '440px',
    m: '572px',
    l: '704px'
  },
  xl: {
    s: '440px',
    m: '572px',
    l: '704px'
  }
};

export { ANIMATION_FALL_BACK_TIME_MS, SIDE_SHEET_CLOSE_BUTTON_ARIA_LABEL, SIDE_SHEET_CLOSE_KEY, SIDE_SHEET_SIZE, SIDE_SHEET_TRANSFORM, SIDE_SHEET_TRANSITION };
//# sourceMappingURL=constants.js.map
